import { c as _c } from "react/compiler-runtime";
interface Props {
  setPcFontSize: (size: number) => void;
}
function ChatFontSizeButtons(t0) {
  const $ = _c(10);
  const {
    setPcFontSize
  } = t0;
  let t1;
  if ($[0] !== setPcFontSize) {
    t1 = <button data-gtm-chat-font-size="13" type="button" onClick={() => {
      setPcFontSize(13);
    }} className="h-[30px] w-[30px] rounded-full border-[1px] border-borderBg02 bg-colorBg14 text-[12px] text-colorFg07">{"\uAC00"}</button>;
    $[0] = setPcFontSize;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setPcFontSize) {
    t2 = <button data-gtm-chat-font-size="15" type="button" onClick={() => {
      setPcFontSize(15);
    }} className="h-[30px] w-[30px] rounded-full border-[1px] border-borderBg02 bg-colorBg14 text-[14px] text-colorFg07">{"\uAC00"}</button>;
    $[2] = setPcFontSize;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== setPcFontSize) {
    t3 = <button data-gtm-chat-font-size="17" type="button" onClick={() => {
      setPcFontSize(19);
    }} className="h-[30px] w-[30px] rounded-full border-[1px] border-borderBg02 bg-colorBg14 text-[17px] text-colorFg07">{"\uAC00"}</button>;
    $[4] = setPcFontSize;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex [&>*]:mr-2">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export default ChatFontSizeButtons;